var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B9\\u30BF\\u30C3\\u30D5\\u30FB\\u6559\\u5E2B\\u4E00\\u89A7",
    transform: "translate(-250.000000, -197.000000)",
    stroke: "#4A90E2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Btn50_split-/-icon-/-Default",
    transform: "translate(240.000000, 185.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-Search",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.6,
    y1: 14.4,
    x2: 19.2,
    y2: 20,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,8 C16.8,12.4184371 13.0389907,16 8.39974215,16 C3.7604936,16 0,12.4184371 0,8 C0,3.58156293 3.7604936,0 8.39974215,0 C13.0389907,0 16.8,3.58156293 16.8,8 L16.8,8 Z",
    id: "Stroke-5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.099a5d46779d9621477da8b29b220b01.svg";
export { ForwardRef as ReactComponent };